import 'es6-promise/auto';
import Vue from 'vue';
import App from './App.vue';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import DefaultLayoutEn from '@/layouts/DefaultLayoutEn.vue';
import NoneLayout from '@/layouts/NoneLayout.vue';
import LoginLayout from '@/layouts/LoginLayout.vue'
import router from './router';
// import VueAnalytics from 'vue-analytics';
import VueGtm from '@gtm-support/vue2-gtm';
import store from './store';
import axios, {AxiosRequestConfig, AxiosProxyConfig, AxiosResponse, AxiosError} from 'axios';
import VueAxios from 'vue-axios';
import $ from 'jquery';
import Platform from 'platform';
Vue.component('default-layout', DefaultLayout);
Vue.component('default-en-layout', DefaultLayoutEn);
Vue.component('none-layout', NoneLayout);
Vue.component('login-layout', LoginLayout);

const platform: any = Platform;
if (platform.name === 'IE') { // IE
  $('body').addClass('ie');
} else if (platform.os.family === 'iOS' || platform.os.family === 'Android') { // mobile device
  $('body').addClass('mobile');
} else if (platform.os.family === 'OS X' && typeof document.ontouchstart !== 'undefined') { // iPad
  $('body').addClass('mobile');
}

import '@/assets/style.scss';

Vue.config.productionTip = false;
Vue.use(VueAxios, axios);

// Vue.use(VueGtm, {
//   id: 'GTM-5GG4QQB7',
// });

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
